import { Menu } from "antd";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import { Colors, Fonts, Images } from "../../config";
import Text from "../CommonComponents/Text";
import adManagement from "../../assets/images/adManagement.png";
import { IoIosChatboxes, IoIosLogOut } from "react-icons/io";
import { FaUserFriends } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";
import { AuthAction } from "../../store/actions";

// ProfileDropDown

const dropdownItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px'
}

const dropdownHeadingMargin = {
  marginLeft: '10px'
}

const ProfileDropDown = (props) => {

  let adminRole;
  const authUser = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (authUser.user) {
    adminRole = authUser.user.roleId;
  } else {
    const authLS = JSON.parse(localStorage.getItem("authUser"));
    adminRole = authLS.user.roleId;
  }

  const handleLogout = () => {
    dispatch(AuthAction.logout());
  };

  return (
    <div className="dropDownContainer profileDropDownContainer">
      <Menu className="dropDownList">
        {/* <Menu.Item className="dropDownItem">
          <a
            onClick={() => {
              navigate("ad-management");
            }}
          >
            <img
              width="20px"
              height="20px"
              src={adManagement}
              alt="disappear"
            />
            <Text.Heading
              className={dropdownHeadingMargin}
              text="Ad Management"
              textAlign="left"
              marginTop={0}
              fontSize={16}
              fontFamily={Fonts["Poppins-Medium"]}
              fontWeight={500}
              color={Colors.Black}
            />
          </a>
        </Menu.Item> */}
        <Menu.Item className="dropDownItem">
          <a
            onClick={() => {
              navigate("contact-support");
            }}
            className="dropdownItemStyle"
          >
            <IoIosChatboxes color={Colors.Black} size={20} />
            <Text.Heading
              className={dropdownHeadingMargin}
              text="Contact Support"
              textAlign="left"
              marginTop={0}
              fontSize={16}
              fontFamily={Fonts["Poppins-Medium"]}
              fontWeight={500}
              color={Colors.Black}
            />
          </a>
        </Menu.Item>
        {adminRole === 2 && (
          <Menu.Item className="dropDownItem">
            <a
              onClick={() => {
                navigate("sub-admin-management");
              }}
              className="dropdownItemStyle"
            >
              <FaUserFriends color={Colors.Black} size={20} />
              <Text.Heading
                className={dropdownHeadingMargin}
                text="Sub-Admin"
                textAlign="left"
                marginTop={0}
                fontSize={16}
                fontFamily={Fonts["Poppins-Medium"]}
                fontWeight={500}
                color={Colors.Black}
              />
            </a>
          </Menu.Item>
        )}
        <Menu.Item className="dropDownItem">
          <a
            onClick={() => handleLogout()}
            className="dropdownItemStyle"
          >
            <RiLogoutBoxLine color={Colors.Black} size={23} />
            <Text.Heading
              className={dropdownHeadingMargin}
              text="Logout"
              textAlign="left"
              marginTop={0}
              fontSize={16}
              fontFamily={Fonts["Poppins-Medium"]}
              fontWeight={500}
              color={Colors.Black}
            />
          </a>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default ProfileDropDown;
